import { JSX } from 'react';

import '@src/components/circle-image-modifier/index.scss';

export function CircleImageModifier({
  imgSrc,
  altTxt = '',
  accPos = 'right',
  pxSize = 160,
  accent = true,
  circle = true,
  className = '',
  lazy = false,
}: {
  imgSrc: string;
  altTxt?: string;
  accPos?: 'right' | 'left';
  pxSize?: number;
  accent?: boolean;
  circle?: boolean;
  className?: string;
  lazy?: boolean;
}): JSX.Element {
  const position = new Map();

  const status = (value: boolean): string => {
    return value == true ? 'on' : 'off';
  };

  position.set('right', 270);
  position.set('left', 180);

  const imageToLoad = lazy ? (
    <img className="lazyload" data-src={imgSrc} alt={altTxt} />
  ) : (
    <img src={imgSrc} alt={altTxt} />
  );

  return (
    <div
      className={`pi-image accent-${status(accent)} circle-${status(circle)}${
        ' ' + className
      }`}
    >
      <svg
        role="img"
        fill="none"
        width={pxSize}
        height={pxSize}
        stroke="#fff"
        strokeWidth="2"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 100 100"
        strokeDasharray="360"
        strokeLinecap="round"
        strokeDashoffset="300"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          style={{ transformOrigin: 'center center' }}
          transform={`rotate(${position.get(accPos)})`}
          cx="48.5"
          cy="48.5"
          r="44"
        />
      </svg>

      {imageToLoad}
    </div>
  );
}
